/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

import {
	ContentComponentContextProvider,
	type ContentComponentProps,
} from '../../hooks/useContentComponentContext';
import { GlobalWrapper } from '../GlobalWrapper/GlobalWrapper';

import { ContentComponent } from './ContentComponent';

export const ContentComponentWrapper = (props: ContentComponentProps) => {
	return (
		<GlobalWrapper>
			<ContentComponentContextProvider value={{ ...props }}>
				<ContentComponent />
			</ContentComponentContextProvider>
		</GlobalWrapper>
	);
};
